module.exports = __webpack_public_path__ + "static/media/triangle-error-grey-24x24.43727089.svg";